import script from "./OnboardingStepper.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardingStepper.vue?vue&type=script&setup=true&lang=js"

import "./OnboardingStepper.vue?vue&type=style&index=0&id=90894d0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90894d0a"]])

export default __exports__